module.exports = "https://static.wmbcdn.com/uniweb/images/4c6210daac79ce778039c4c8f3629996.svg";